import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const resendOtp = createAsyncThunk('resendOtp/send', async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + 'resend_otp',
      data: {
        email: data?.email || ''
      },
      headers: { 'Content-Type': 'application/json' }
    });
    return res;
  } catch (error) {
    return error.response;
  }
});

const initialState = {
  loading: false,
  error: null,
  apiResponse: null,
  success: false
};

const resendOtpSlice = createSlice({
  name: 'resendOtp',
  initialState,
  reducers: {
    clearResendState: (state) => {
      state.loading = false;
      state.error = null;
      state.apiResponse = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resendOtp.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(resendOtp.fulfilled, (state, action) => {
      state.loading = false;
      const httpOk = action?.payload?.status === 200 || action?.payload?.status === 201;
      const apiOk = action?.payload?.data?.status === true;
      state.success = Boolean(httpOk && apiOk);
      state.apiResponse = action.payload;
    });
    builder.addCase(resendOtp.rejected, (state) => {
      state.loading = false;
      state.error = 'Network error occurred';
      state.success = false;
    });
  }
});

export const { clearResendState } = resendOtpSlice.actions;

export default resendOtpSlice.reducer;


